import Vue from 'vue';
import VueI18n from 'vue-i18n';
import store from '@/store/index';

import Languages from '@/i18n/locale';

// 使用浏览器语言
const lang = (navigator.language || navigator.browserLanguage).toLowerCase();
store.commit('setLocale', lang);
const locale = store.state.locale;

Vue.use(VueI18n);

export default new VueI18n({
    locale,
    messages: Languages
});
